import {
  useQuery, useInfiniteQuery, UseQueryResult, UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getUsers } from '../../services/UsersService';
import { UsersResponse } from '../../types/Users';
import { FeaturesManagement } from '../../../featuresControl';

function useGetUsers(fleetId: string, query: string): UseQueryResult<UsersResponse> {
  return useQuery(
    ['users', fleetId, query],
    async (): Promise<UsersResponse> => getUsers(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export function useGetUsersLazy(fleetId: string, query?: string, deps?: any): UseInfiniteQueryResult<UsersResponse> {
  return useInfiniteQuery(
    ['users-lazy', fleetId, deps],
    async ({ pageParam = query }): Promise<UsersResponse> => getUsers(fleetId, pageParam),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      cacheTime: 0,
      getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    },
  );
}

export default useGetUsers;
